<ion-item color="light">
  <ion-select
    [formControl]="formControl"
    [placeholder]="props.placeholder"
    [attr.label-placement]="props['labelPlacement']"
    [interface]="props['interface']"
  >
    <div slot="label">{{ this.translocoService.translate(props.label!) }}<ion-text *ngIf="props.required" color="danger"> *</ion-text></div>
    <ion-select-option 
      *ngFor="let option of selectOptions" 
      [value]="option.value"
    >
      {{ this.translocoService.translate(option.label) }}
    </ion-select-option>
  </ion-select>
  <ion-note
  *ngIf="showError"
    color="danger"
    class="text-sm"
    slot="end"
  >
    {{ errorMessage }}
  </ion-note>
</ion-item>